import { Button } from "../shared/Button";
import ProductCard from "./product-card";
import { Product } from "../../api/products";
import { formatterNoDecimal, formatter } from "../shared/util";

export default function DevicesAPIProduct({
  product,
  isActive,
  onSubscribe,
  isSubscribing,
  isSandbox,
}: {
  product: Product;
  isActive: boolean;
  onSubscribe: ({ subscribeDevices }: { subscribeDevices: boolean }) => void;
  isSubscribing: boolean;
  isSandbox: boolean;
}) {
  const flatRate = product.flatRate
    ? formatterNoDecimal.format(product.flatRate / 100)
    : formatterNoDecimal.format(0);
  const pricePerUser = product.pricePerUser ? formatter.format(product.pricePerUser / 100) : null;

  return (
    <ProductCard
      name={product.name}
      pricingDetailsUrl="https://www.metriport.com/devices#pricing"
      isActive={isActive}
      flatRate={flatRate}
      nOfUsers={product.upToAmount}
      pricePerUser={pricePerUser}
      footer={
        !isSandbox && (
          <Button
            size={"lg"}
            isLoading={isSubscribing}
            onClick={() => {
              onSubscribe({ subscribeDevices: true });
            }}
          >
            {isActive ? "Manage Subscription" : "Get Started"}
          </Button>
        )
      }
    />
  );
}
